<template lang="html">
  <div class="columns">
  <div class="column">
      <p class="notification is-primary">
        First column
      </p>
    </div>
    <div class="column">
      <p class="notification is-info">
        First column
      </p>
    </div>
    <div class="column">
      <p class="notification is-success">
        First column
      </p>
    </div>
    <div class="column">
      <p class="notification is-warning">
        First column
      </p>
    </div>
    <div class="column">
      <p class="notification is-danger">
        First column
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'columns'
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// columns.vue?02cc973e